import { render } from "./EditChecklistModel.vue?vue&type=template&id=662ddf10"
import script from "./EditChecklistModel.vue?vue&type=script&lang=js"
export * from "./EditChecklistModel.vue?vue&type=script&lang=js"
script.render = render

export default script